export const VARIANT = {
  BRAND: "brand",
  INFO: "info",
  WARNING: "warning",
  DANGER: "danger",
};
